import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { isCompanyAdmin } from '../authStorage';

const PendingRegistrationsPage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');
  const [busyId, setBusyId] = useState(null);
  const admin = isCompanyAdmin();

  async function load() {
    setMsg('');
    try {
      const res = await api.get('/users/pending-registrations');
      setRows(res.data || []);
    } catch (e) {
      setMsg(e.response?.data?.error || e.message || 'Không tải được danh sách');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!admin) {
      setLoading(false);
      return;
    }
    load();
  }, [admin]);

  async function approve(id) {
    setBusyId(id);
    setMsg('');
    try {
      await api.post(`/users/${id}/approve`);
      setMsg('Đã duyệt.');
      await load();
    } catch (e) {
      setMsg(e.response?.data?.error || e.message || 'Lỗi');
    } finally {
      setBusyId(null);
    }
  }

  async function reject(id) {
    if (!window.confirm('Từ chối đăng ký này? Người dùng sẽ không đăng nhập được.')) return;
    setBusyId(id);
    setMsg('');
    try {
      await api.post(`/users/${id}/reject`);
      setMsg('Đã từ chối.');
      await load();
    } catch (e) {
      setMsg(e.response?.data?.error || e.message || 'Lỗi');
    } finally {
      setBusyId(null);
    }
  }

  if (!admin) {
    return (
      <div>
        <p style={{ color: '#b91c1c' }}>Chỉ quản trị công ty mới xem được trang này.</p>
        <Link to="/projects">Về dự án</Link>
      </div>
    );
  }

  if (loading) return <p>Đang tải…</p>;

  return (
    <div>
      <h2>Duyệt đăng ký tài khoản</h2>
      <p style={{ color: '#64748b', fontSize: 14, maxWidth: 640 }}>
        Người dùng tự đăng ký bằng <strong>email</strong> (là tên đăng nhập). Sau khi duyệt, họ mới đăng nhập được.
        Hệ thống <strong>tự tạo một đội thi công riêng cho họ trên mỗi dự án</strong> (họ là lead) — không cần gán
        tay. Quản trị vẫn có thể{' '}
        <Link to="/projects">thêm họ vào đội chung</Link> tại chi tiết dự án nếu cần phối hợp nhóm.
      </p>
      {msg && (
        <p className={`page-alert ${msg.startsWith('Đã') ? 'page-alert--success' : 'page-alert--error'}`}>{msg}</p>
      )}
      <table border="1" cellPadding={8} style={{ width: '100%', marginTop: 16, borderCollapse: 'collapse' }}>
        <thead style={{ background: '#f1f5f9' }}>
          <tr>
            <th align="left">Email / tên đăng nhập</th>
            <th>Ngày đăng ký</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{r.email || r.username}</td>
              <td>{r.created_at ? new Date(r.created_at).toLocaleString('vi-VN') : '—'}</td>
              <td style={{ whiteSpace: 'nowrap' }}>
                <button
                  type="button"
                  disabled={busyId === r.id}
                  onClick={() => approve(r.id)}
                  style={{
                    padding: '6px 14px',
                    marginRight: 8,
                    border: 'none',
                    borderRadius: 6,
                    background: busyId === r.id ? '#94a3b8' : '#059669',
                    color: '#fff',
                    fontWeight: 600,
                    cursor: busyId === r.id ? 'wait' : 'pointer',
                  }}
                >
                  Duyệt
                </button>
                <button
                  type="button"
                  disabled={busyId === r.id}
                  onClick={() => reject(r.id)}
                  style={{
                    padding: '6px 14px',
                    border: 'none',
                    borderRadius: 6,
                    background: busyId === r.id ? '#94a3b8' : '#dc2626',
                    color: '#fff',
                    fontWeight: 600,
                    cursor: busyId === r.id ? 'wait' : 'pointer',
                  }}
                >
                  Từ chối
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {rows.length === 0 && <p className="page-muted-box" style={{ marginTop: 16 }}>Không có đăng ký chờ duyệt.</p>}
      <p style={{ marginTop: 24 }}>
        <Link to="/projects">← Về dự án</Link>
      </p>
    </div>
  );
};

export default PendingRegistrationsPage;
